// Environment variable accessor that works both in dev and production
// In production, values from window._env_ (set by Docker runtime) take precedence
// In development, values from import.meta.env are used

declare global {
  interface Window {
    _env_?: {
      VITE_KEYCLOAK_CLIENT_REALM?: string
      VITE_CLAIMS_SERVICE_URL?: string
      VITE_CALLS_SERVICE_URL?: string
      VITE_TENANT_ROLE_USER_SERVICE_URL?: string
      VITE_ENABLE_ENV_FEATURES?: string
      VITE_CALLS_SERVICE_WSS?: string
      VITE_IDEAL_LOGOUT_TIME?: string
      VITE_AGGRID_LICENSE_KEY?: string
    }
  }
}

export const env = {
  get VITE_KEYCLOAK_CLIENT_REALM(): string {
    // In development, prioritize env variables over window._env_ to avoid placeholder issues
    const envValue = import.meta.env.VITE_KEYCLOAK_CLIENT_REALM || ''
    const windowValue = window._env_?.VITE_KEYCLOAK_CLIENT_REALM || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_keycloak_client_realm__')) {
      return envValue
    }

    return windowValue || envValue
  },
  get VITE_CLAIMS_SERVICE_URL(): string {
    const envValue = import.meta.env.VITE_CLAIMS_SERVICE_URL || ''
    const windowValue = window._env_?.VITE_CLAIMS_SERVICE_URL || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_claims_url__')) {
      return envValue
    }

    return windowValue || envValue
  },
  get VITE_CALLS_SERVICE_URL(): string {
    const envValue = import.meta.env.VITE_CALLS_SERVICE_URL || ''
    const windowValue = window._env_?.VITE_CALLS_SERVICE_URL || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_calls_url__')) {
      return envValue
    }

    return windowValue || envValue
  },
  get VITE_TENANT_ROLE_USER_SERVICE_URL(): string {
    const envValue = import.meta.env.VITE_TENANT_ROLE_USER_SERVICE_URL || ''
    const windowValue = window._env_?.VITE_TENANT_ROLE_USER_SERVICE_URL || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_tenant_role_user_url__')) {
      return envValue
    }

    return windowValue || envValue
  },
  get VITE_ENABLE_ENV_FEATURES(): string {
    const envValue = import.meta.env.VITE_ENABLE_ENV_FEATURES || ''
    const windowValue = window._env_?.VITE_ENABLE_ENV_FEATURES || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_enable_env_features__')) {
      return envValue
    }

    return windowValue || envValue
  },
  get VITE_CALLS_SERVICE_WSS(): string {
    const envValue = import.meta.env.VITE_CALLS_SERVICE_WSS || ''
    const windowValue = window._env_?.VITE_CALLS_SERVICE_WSS || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_calls_ws__')) {
      return envValue
    }

    return windowValue || envValue
  },
  get VITE_IDEAL_LOGOUT_TIME(): string {
    const envValue = import.meta.env.VITE_IDEAL_LOGOUT_TIME || ''
    const windowValue = window._env_?.VITE_IDEAL_LOGOUT_TIME || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_ideal_logout_time__')) {
      return envValue
    }

    return windowValue || envValue
  },
  get VITE_AGGRID_LICENSE_KEY(): string {
    const envValue = import.meta.env.VITE_AGGRID_LICENSE_KEY || ''
    const windowValue = window._env_?.VITE_AGGRID_LICENSE_KEY || ''

    // If window._env_ contains placeholder, use environment variable instead
    if (windowValue.includes('__OAI_aggrid_license__')) {
      return envValue
    }

    return windowValue || envValue
  },
}
